import { Fragment, createContext } from 'react'

/** @type {React.Context<(props: { children?: React.ReactNode }) => React.ReactNode>} */
const ScrollWrapper = createContext(Fragment)

export default ScrollWrapper



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/contexts/ScrollWrapper.js